/* eslint-disable import/order */
import React from 'react';
import RedirectToLegacyRouting from '@jira/spa-apps__common/src/LegacyRoutingDefaultExport.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { legacyRedirectRoute } from '@jira/router-routes__legacy-redirect-routes/src/legacyRedirectRoute.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

// @ts-expect-error - Type '{}' is missing the following properties from type 'Pick<Omit<Omit<RouteContext & { flagService: FlagService; createAnalyticsEvent: (arg1: { action: string; }) => UIAnalyticsEvent; }, keyof WithAnalyticsEventsProps> & RefAttributes<...>, "flagService">, keyof RouteContext | keyof RefAttributes<...>>': query, location, route, match, action
const RedirectComponent = () => <RedirectToLegacyRouting />;

export const legacyRedirectRouteEntry: Route = createEntry(legacyRedirectRoute, () => ({
	// eslint-disable-next-line no-restricted-syntax
	component: RedirectComponent,
	layout: globalLayout,
	resources: [...jiraSpaResources()],
	isRedirect: true,
	canTransitionIn: () => false,
	forPaint: [LazyAtlassianNavigation],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
